/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { JSONWebKeySet, JSONWebKeySet$inboundSchema } from "./jsonwebkeyset.js";

export type ListJSONWebKeySetsResult = {
  /**
   * The organization's JSON Web Key Sets.
   */
  sets: Array<JSONWebKeySet>;
};

/** @internal */
export const ListJSONWebKeySetsResult$inboundSchema: z.ZodMiniType<
  ListJSONWebKeySetsResult,
  unknown
> = z.object({
  sets: z.array(JSONWebKeySet$inboundSchema),
});

export function listJSONWebKeySetsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListJSONWebKeySetsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListJSONWebKeySetsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListJSONWebKeySetsResult' from JSON`,
  );
}
